import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import type {
  AdminPostDto,
  CreatePostDto,
  PostDto,
  PostListDto,
  UpdatePostDto,
} from '@plugins/newsfeed-lib/types';

/**
 * Editor-only endpoints. The server rejects non-editors with `403`
 * (PRD §3), the client never relies on `RoleService` for authorisation.
 */
@Injectable({
  providedIn: 'root',
})
export class AdminPostsService {
  private readonly http = inject(HttpClient);

  /** Backoffice list: drafts included, with acknowledgement counts. */
  list(skip: number, take: number): Observable<PostListDto<AdminPostDto>> {
    return this.http.get<PostListDto<AdminPostDto>>('/api/admin/posts', {
      params: { skip, take },
    });
  }

  /** Single post for the edit form. Unlike the feed route, drafts included. */
  get(id: string): Observable<PostDto> {
    return this.http.get<PostDto>(`/api/admin/posts/${id}`);
  }

  create(post: CreatePostDto): Observable<PostDto> {
    return this.http.post<PostDto>('/api/admin/posts', post);
  }

  update(id: string, post: UpdatePostDto): Observable<PostDto> {
    return this.http.put<PostDto>(`/api/admin/posts/${id}`, post);
  }

  remove(id: string): Observable<void> {
    return this.http.delete<void>(`/api/admin/posts/${id}`);
  }
}
